import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  CONTA_BANCARIA_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    CONTA_BANCARIA_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    CONTA_BANCARIA_ENDPOINT,
    id,
  ]);
}

export async function register(data, queryParams = []) {
  return doPostQCXRequest(
    [CONTA_BANCARIA_ENDPOINT],
    data,
    queryParams
  );
}

export async function save(data, queryParams = []) {
  return doPutQCXRequest(
    [CONTA_BANCARIA_ENDPOINT],
    data,
    queryParams
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [CONTA_BANCARIA_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [CONTA_BANCARIA_ENDPOINT],
    id
  );
}
